import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function MidPageCTA() {
  return <section className="w-full py-16 px-4 bg-gradient-to-r from-[#111111] via-[#1a1a1a] to-[#111111] border-y border-gray-800" data-id="element-130">
      <div className="max-w-4xl mx-auto text-center" data-id="element-131">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="flex flex-col md:flex-row items-center justify-between gap-8" data-id="element-132">
          <div className="text-left space-y-2" data-id="element-133">
            <h3 className="text-2xl md:text-3xl font-bold text-white uppercase tracking-wide" data-id="element-134">
              Ready to take control of your numbers?
            </h3>
            <p className="text-gray-400 text-sm md:text-base" data-id="element-135">
              The protocol is waiting. 47 pages of actionable{' '}
              <span className="text-accent font-semibold" data-id="element-136">
                metabolic engineering
              </span>
              .
            </p>
          </div>

          <button onClick={() => document.getElementById('final-cta')?.scrollIntoView({
          behavior: 'smooth'
        })} className="flex-shrink-0 w-full md:w-auto px-8 py-4 bg-accent hover:bg-[#d55515] text-white font-bold rounded shadow-lg glow-orange transition-all duration-300 transform hover:scale-105 flex items-center justify-center gap-2 uppercase tracking-wider text-sm md:text-base" data-id="element-137">
            Get The Protocol — $6.36
            <ArrowRight className="w-5 h-5" data-id="element-138" />
          </button>
        </motion.div>
      </div>
    </section>;
}